/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import { Button, Icon } from 'semantic-ui-react'
import DeleteModal from '../deleteComponent/deleteModal'
import DeleteAxios from '../axiosComponent/delete'

function CheckListActionButton(props) {
    const [Id, setId] = useState('')
    const [openBox, setopenBox] = useState(false)
    const [success, setsuccess] = useState(false)
    const [fields, setfields] = useState(props.data)
    let handleClose = () => {
        setopenBox(false)
    }
    let handleDelete = () => {
        setsuccess(true)
        let id = Id
        DeleteAxios({
            url: 'fleet/checklist/delete',
            deleteItems: {
                checkListId: id
            },
            deleted: (data) => {
                if (data && data.status === 1) {
                    setTimeout(() => {
                        setsuccess(false)
                        window.location.reload()
                    }, 500);
                } else {
                    setsuccess(false)
                    alert(data.message)
                }
            }
        })

    }//
    let handleOpenEdit = (e) => {
        let mainData = props.data
        console.log('checklist props', props)
        let history = props.agGridReact.props.BaseUrl.history
        history.push({ pathname: '/edit-checklist', state: { id: mainData.checkListId } })
        // localStorage.setItem('vehId', mainData.id)
        // window.location.href = '/vehicle-info'
    }
    let handleOpenDelete = (e) => {
        let mainData = props.data
        setId(mainData.checkListId)
        setopenBox(true)
    }
    return (
        <>
            <Button disabled={fields.customerNo === 0 ? true : false} onClick={handleOpenEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button>
            <Button disabled={fields.customerNo === 0 ? true : false} onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button>
            <DeleteModal isloading={success} open={openBox} onClose={handleClose} handleDelete={handleDelete} />
        </>
    )
}

export default CheckListActionButton
